import React, { Component } from 'react';
import '../css/backAgente.css';
import { Col, Row, Card, CardBody, Label, Input, FormGroup, Button, Progress, FormFeedback } from 'reactstrap';
import Timer from "react-time-counter";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MensajeModal from "../components/MensajeModal";
import axios from "axios";
import { OBTENER_URL_SERVICIO } from "../constants/action-types";
import { logout } from '../actions/index';

const mapStateToProps = state => {
  return { agente: state.agente };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({ logout }, dispatch)
  };
};

class DatosAtencionAgente extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modalEstado: false,
      modalTitulo: "",
      modalMensaje: "",
      modalFooter: "",
      estadoFlujo: "Finalizado",
      turnoActual: {
        idTurno: "XX-XX",
        usuario: " ",
        idUsuario: " ",
        correoUsuario: "",
        telefonoUsuario: "",
        observacionesServicio: "",
        nombreServicio: ""
      },
      turnoTotal: "",
      boolNombre: false,
      boolID: false,
      boolCorreo: false,
      boolTelefono: false,
      boolObservaciones: false,

      modalAgenteTransferir: {
        idAgenteBase: "",
        nombreAgenteBase: ""
      },

      modalPrioritario: {
        nombreUsuario: "",
        idUsuario: "",
        rolUsuario: "EXTERNO",
        idRolUsuario: "2",
        generoUsuario: "M",
        observaciones: "",
        correoUsuario: "",
        telefonoUsuario: "",
        idServicio: "",
        nombreServicio: "",
      },
      modalInvalidNombre: false,
      modalInvalidIdentificacion: false,
      modalInvalidCorreo: false,
      modalInvalidTelefono: false,
      modalInvalidObservaciones: false,
      invalidNombre: false,
      invalidIdentificacion: false,
      invalidCorreo: false,
      invalidTelefono: false,
      invalidObservaciones: false,
    };
    this.llamarSiguiente = this.llamarSiguiente.bind(this);
    this.finalizar = this.finalizar.bind(this);
    this.toggle = this.toggle.bind(this);
    this.modalAtencionPrioritaria = this.modalAtencionPrioritaria.bind(this);
    this.cancelar = this.cancelar.bind(this);
    this.posponer = this.posponer.bind(this);
    this.transferir = this.transferir.bind(this)
    this.prioritario = this.prioritario.bind(this);
    this.modalTransferir = this.modalTransferir.bind(this);
    this.handleChangeModal = this.handleChangeModal.bind(this);
    this.handleChangeDatos = this.handleChangeDatos.bind(this);
    this.validarTurnoPendiente = this.validarTurnoPendiente.bind(this);
    this.handleSelectGenero = this.handleSelectGenero.bind(this);
    this.handleSelectRoles = this.handleSelectRoles.bind(this);
    this.handleSelectServicio = this.handleSelectServicio.bind(this);
    this.handleSelectTransferir = this.handleSelectTransferir.bind(this);
  }

  toggle() {
    var serviciosX = []
    for (const [key, value] of Object.entries(this.props.agente.mapaServicios)) {
      serviciosX.push({ id: key, valor: value });
    }
    const idServicioBase = serviciosX[0].id;
    const nomServicioBase = serviciosX[0].valor;
    var modal = {
      nombreUsuario: "",
      idUsuario: "",
      rolUsuario: "EXTERNO",
      idRolUsuario: "2",
      generoUsuario: "M",
      observaciones: "",
      correoUsuario: "",
      telefonoUsuario: "",
      idServicio: idServicioBase,
      nombreServicio: nomServicioBase,
    };
    this.setState({
      modalEstado: !this.state.modalEstado,
      modalInvalidNombre: false,
      modalInvalidIdentificacion: false,
      modalInvalidCorreo: false,
      modalInvalidTelefono: false,
      modalInvalidObservaciones: false,
      modalPrioritario: modal
    });
  }

  handleSelectGenero(e) {
    var x = this.state.modalPrioritario;
    x.generoUsuario = e.target.selectedOptions[0].id;;
    this.setState({
      modalPrioritario: x,
    })
  }

  handleSelectServicio(e) {
    var x = this.state.modalPrioritario;
    x.nombreServicio = e.target.selectedOptions[0].id;;
    x.idServicio = e.target.selectedOptions[0].value;
    this.setState({
      modalPrioritario: x,
    })
  }

  handleSelectRoles(e) {
    var x = this.state.modalPrioritario;
    x.rolUsuario = e.target.selectedOptions[0].id;
    x.idRolUsuario = e.target.selectedOptions[0].value;
    this.setState({
      modalPrioritario: x,
    })
  }

  componentDidMount() {
    this.validarTurnoPendiente();

    var serviciosX = []
    for (const [key, value] of Object.entries(this.props.agente.mapaServicios)) {
      serviciosX.push({ id: key, valor: value });
    }

    if (serviciosX.length <= 0) {
      this.setState({
        modalTitulo: "Error",
        modalMensaje:
          <div>
            <center>
              <p>No tienes permisos para atender algún servicio. Por favor acércate al Departament de TICs de la Universidad.</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <center>
            <Label><Timer seconds={10} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
          </center>
        </div>,
      })
      this.toggle();
      setTimeout(
        function () {
          this.props.logout();
        }
          .bind(this),
        10000
      );
    } else {
      const idServicioBase = serviciosX[0].id;
      const nomServicioBase = serviciosX[0].valor;

      var modalBase = this.state.modalPrioritario;
      modalBase.nombreServicio = nomServicioBase;
      modalBase.idServicio = idServicioBase;
      this.setState({
        modalPrioritario: modalBase,
      })
    }
  }

  async validarTurnoPendiente() {
    try {
      const response = await axios.get(OBTENER_URL_SERVICIO + "/validarAtenderTurno/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente);
      if (response.data !== null) {
        var x;
        this.props.ocuparAgente(true);
        if (response.data.rolSeleccionado.rol === "EXTERNO") {
          x = {
            idTurno: response.data.numeroTurno,
            usuario: response.data.nombreUsuario,
            idUsuario: response.data.identificacionUsuario,
            correoUsuario: response.data.correo,
            telefonoUsuario: (response.data.telefono === "0" || response.data.telefono === null || response.data.telefono === undefined || response.data.telefono === "" || response.data.telefono < 0) ? "Sin numero" : response.data.telefono,
            nombreServicio: response.data.servicioSeleccionado,
            observacionesServicio: " ",
          }
          this.setState({
            estadoFlujo: "En Atencion",
            boolNombre: true,
            boolID: true,
            boolCorreo: true,
            boolTelefono: true,
            boolObservaciones: true,
            turnoActual: x,
            turnoTotal: response.data,
          })
        }
        else {
          x = {
            idTurno: response.data.numeroTurno,
            usuario: response.data.nombreUsuario,
            idUsuario: response.data.identificacionUsuario,
            correoUsuario: response.data.correo,
            telefonoUsuario: (response.data.telefono === "0" || response.data.telefono === null || response.data.telefono === undefined || response.data.telefono === "" || response.data.telefono < 0) ? "Sin numero" : response.data.telefono,
            nombreServicio: response.data.servicioSeleccionado,
            observacionesServicio: " ",
          }
          this.setState({
            estadoFlujo: "En Atencion",
            boolNombre: false,
            boolID: false,
            boolCorreo: false,
            boolTelefono: false,
            boolObservaciones: true,
            turnoActual: x,
            turnoTotal: response.data,
          })
        }
      } else {
        this.props.ocuparAgente(false);
        //.log("die null")
      }
    } catch (error) {
      //console.log(error)
    }
  }

  handleChangeDatos(e) {
    var envioCambio = this.state.turnoActual;
    const idVariable = e.target.name;
    switch (idVariable) {
      case "usuario":
        if (e.target.value.length <= 120) {
          envioCambio.usuario = e.target.value;
        }
        break;
      case "idUsuario":
        if (e.target.value.length <= 12) {
          envioCambio.idUsuario = e.target.value;
        }
        break;
      case "correoUsuario":
        if (e.target.value.length <= 120) {
          envioCambio.correoUsuario = e.target.value;
        }
        break;
      case "telefonoUsuario":
        if (e.target.value.length <= 60) {
          envioCambio.telefonoUsuario = e.target.value;
        }
        break;
      case "observacionesServicio":
        if (e.target.value.length <= 500) {
          envioCambio.observacionesServicio = e.target.value;
        }
        break;
      default:
    }
    this.setState({
      turnoActual: envioCambio
    })
  }

  handleSelectTransferir(event) {
    var transferirBase = this.state.modalAgenteTransferir;
    transferirBase.idAgenteBase = event.target.value;
    this.setState({
      modalAgenteTransferir: transferirBase,
    })
  }

  handleChangeModal(e) {
    var envioCambio = this.state.modalPrioritario;
    const idVariable = e.target.name;
    //console.log(e.target.name + " : " + e.target.value.length)
    //console.log(e.target.value.length <= 12)
    switch (idVariable) {
      case "nombreUsuario":
        if (e.target.value.length <= 120) {
          envioCambio.nombreUsuario = e.target.value;
        }
        break;
      case "idUsuario":
        if (e.target.value.length <= 12) {
          envioCambio.idUsuario = e.target.value;
        }
        break;
      case "rolUsuario":
        envioCambio.rolUsuario = e.target.value;
        break;
      case "idRolUsuario":
        envioCambio.idRolUsuario = e.target.value;
        break;
      case "generoUsuario":
        envioCambio.generoUsuario = e.target.value;
        break;
      case "observaciones":
        if (e.target.value.length <= 500) {
          envioCambio.observaciones = e.target.value;
        }
        break;
      case "correoUsuario":
        if (e.target.value.length <= 120) {
          envioCambio.correoUsuario = e.target.value;
        }
        break;
      case "telefonoUsuario":
        if (e.target.value.length <= 60) {
          envioCambio.telefonoUsuario = e.target.value;
        }
        break;
      default:
    }
    this.setState({
      modalPrioritario: envioCambio
    })
  }

  async llamarSiguiente() {
    try {
      const response = await axios.get(OBTENER_URL_SERVICIO + "/atenderTurno/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente);
      var x;
      this.props.ocuparAgente(true);
      if (response.data.rolSeleccionado.rol === "EXTERNO") {
        x = {
          idTurno: response.data.numeroTurno,
          usuario: response.data.nombreUsuario,
          idUsuario: response.data.identificacionUsuario,
          correoUsuario: response.data.correo,
          telefonoUsuario: (response.data.telefono === "0" || response.data.telefono === null || response.data.telefono === undefined || response.data.telefono === "" || response.data.telefono < 0) ? "Sin numero" : response.data.telefono,
          nombreServicio: response.data.servicioSeleccionado,
          observacionesServicio: " ",
        }
        this.setState({
          estadoFlujo: "En Atencion",
          boolNombre: true,
          boolID: true,
          boolCorreo: true,
          boolTelefono: true,
          boolObservaciones: true,
          turnoActual: x,
          turnoTotal: response.data,
        })
      }
      else {
        x = {
          idTurno: response.data.numeroTurno,
          usuario: response.data.nombreUsuario,
          idUsuario: response.data.identificacionUsuario,
          correoUsuario: response.data.correo,
          telefonoUsuario: (response.data.telefono === "0" || response.data.telefono === null || response.data.telefono === undefined || response.data.telefono === "" || response.data.telefono < 0) ? "Sin numero" : response.data.telefono,
          nombreServicio: response.data.servicioSeleccionado,
          observacionesServicio: " ",
        }
        this.setState({
          estadoFlujo: "En Atencion",
          boolNombre: false,
          boolID: false,
          boolCorreo: false,
          boolTelefono: false,
          boolObservaciones: true,
          turnoActual: x,
          turnoTotal: response.data,
        })
      }
    } catch (error) {
      this.props.ocuparAgente(false);
      this.setState({
        modalTitulo: "¡Paciencia!",
        modalMensaje:
          <div>
            <p>Por ahora no tienes turnos que atender.</p>
          </div>,
        modalFooter: <Button onClick={this.toggle} color="success"> Aceptar</Button>
      })
      this.toggle();
    }
  }

  async finalizar() {

    //console.log(this.state.turnoActual)
    //console.log("nom: " + this.state.invalidNombre);
    //console.log("ide: " + this.state.invalidIdentificacion);
    //console.log("cor: " + this.state.invalidCorreo);
    //console.log("obs: " + this.state.invalidObservaciones);
    //console.log("tel: " + this.state.invalidTelefono);

    var hayError = false;
    var regexNumber = /^[0-9]+$/;
    var regexTelefono = /^[0-9a-zA-Z/-\s.!?]+$/;
    //var regexString = /^[a-zA-Z]+$/;
    //!this.state.turnoActual.usuario.match(regexString) ||
    //!this.state.turnoActual.idUsuario.toString().match(regexNumber) || 
    if (this.state.turnoActual.usuario === undefined || this.state.turnoActual.usuario === "" || this.state.turnoActual.usuario === null || this.state.turnoActual.usuario <= 1 || this.state.turnoActual.usuario.length >= 120) {
      hayError = true;
      this.setState({
        invalidNombre: true,
      })
    } else {
      this.setState({
        invalidNombre: false,
      })
    }
    if (!this.state.turnoActual.idUsuario.match(regexNumber) || this.state.turnoActual.idUsuario === undefined || this.state.turnoActual.idUsuario === "" || this.state.turnoActual.idUsuario === null || this.state.turnoActual.idUsuario.length <= 1 || this.state.turnoActual.idUsuario.length >= 20) {
      hayError = true;
      this.setState({
        invalidIdentificacion: true,
      })
    } else {
      this.setState({
        invalidIdentificacion: false,
      })
    }
    if (this.state.turnoActual.correoUsuario === undefined || this.state.turnoActual.correoUsuario === "" || this.state.turnoActual.correoUsuario === null || this.state.turnoActual.correoUsuario.length <= 1 || this.state.turnoActual.correoUsuario.length >= 120) {
      hayError = true;
      this.setState({
        invalidCorreo: true,
      })
    } else {
      this.setState({
        invalidCorreo: false,
      })
    }
    if (this.state.turnoActual.telefonoUsuario === undefined || this.state.turnoActual.telefonoUsuario === "" || this.state.turnoActual.telefonoUsuario === null || this.state.turnoActual.telefonoUsuario.length <= 1 || this.state.turnoActual.telefonoUsuario.length >= 60) {
      hayError = true;
      this.setState({
        invalidTelefono: true,
      })
    } else {
      this.setState({
        invalidTelefono: false,
      })
    }
    if (this.state.turnoActual.observacionesServicio === undefined || this.state.turnoActual.observacionesServicio === "" || this.state.turnoActual.observacionesServicio === null || this.state.turnoActual.observacionesServicio.length <= 1 || this.state.turnoActual.observacionesServicio.length >= 500) {
      hayError = true;
      this.setState({
        invalidObservaciones: true,
      })
    } else {
      this.setState({
        invalidObservaciones: false,
      })
    }
    if (hayError === true) {
      return null;
    }
    else {
      try {
        this.setState({
          modalTitulo: "Espera por favor",
          modalMensaje:
            <div>
              <center>
                <p>¡Estamos finalizando el turno!</p>
              </center>
            </div>,
          modalFooter: <div style={{ width: "100%" }}>
            <Progress animated color="success" value="100" />
          </div>,
        })
        this.toggle();
        var envioDatos = this.state.turnoTotal;
        //console.log(envioDatos)
        //console.log(this.state.turnoTotal)
        //console.log("try")
        envioDatos.observaciones = this.state.turnoActual.observacionesServicio;
        envioDatos.nombreUsuario = this.state.turnoActual.usuario;
        envioDatos.identificacionUsuario = this.state.turnoActual.idUsuario;
        envioDatos.correo = this.state.turnoActual.correoUsuario;
        envioDatos.telefono = this.state.turnoActual.telefonoUsuario;
        const response = await axios.post(OBTENER_URL_SERVICIO + "/finalizarTurno/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente, envioDatos);
        if (response.data.tipo === "EXITO") {
          this.props.ocuparAgente(false);
          //console.log("try EX")
          this.setState({
            estadoFlujo: "Finalizado",
            boolNombre: false,
            boolID: false,
            boolCorreo: false,
            boolTelefono: false,
            boolObservaciones: false,
            modalTitulo: "Exito",
            modalMensaje:
              <div>
                <center>
                  <p>Turno finalizado con éxito.</p>
                </center>
              </div>,
            modalFooter: <div>
              <Button onClick={this.toggle}> Aceptar</Button>
            </div>
          })
        } else {
          //console.log("try Err")
          this.setState({
            modalTitulo: "Error",
            modalMensaje:
              <div>
                <center>
                  <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (200 Response Error)</p>
                </center>
              </div>,
            modalFooter: <div style={{ width: "100%" }}>
              <center>
                <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
              </center>
            </div>,
          })
          setTimeout(
            function () {
              this.toggle();
            }
              .bind(this),
            5000
          );
        }
      } catch (error) {
        //console.log("catch")
        this.setState({
          modalTitulo: "Error",
          modalMensaje:
            <div>
              <center>
                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
              </center>
            </div>,
          modalFooter: <div style={{ width: "100%" }}>
            <center>
              <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
            </center>
          </div>,
        })
        setTimeout(
          function () {
            this.toggle();
          }
            .bind(this),
          5000
        );
      }
    }
  }

  async cancelar() {
    try {
      this.setState({
        modalTitulo: "Espera por favor",
        modalMensaje:
          <div>
            <center>
              <p>¡Estamos cancelando el turno!</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <Progress animated color="success" value="100" />
        </div>,
      })
      var envioDatos = this.state.turnoTotal;
      //console.log(envioDatos)
      //console.log(this.state.turnoTotal)
      //envioDatos.observaciones = "Cancelación Observación";
      this.toggle();
      const response = await axios.post(OBTENER_URL_SERVICIO + "/cancelarTurno/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente, envioDatos);
      if (response.data.tipo === "EXITO") {
        this.props.ocuparAgente(false);
        this.setState({
          estadoFlujo: "Finalizado",
          boolNombre: false,
          boolID: false,
          boolCorreo: false,
          boolTelefono: false,
          boolObservaciones: false,
          modalTitulo: "Exito",
          modalMensaje:
            <div>
              <center>
                <p>Turno cancelado con éxito.</p>
              </center>
            </div>,
          modalFooter: <div>
            <Button onClick={this.toggle}> Aceptar</Button>
          </div>,
        })
      } else {
        this.setState({
          modalTitulo: "Error",
          modalMensaje:
            <div>
              <center>
                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (200 Response Error)</p>
              </center>
            </div>,
          modalFooter: <div style={{ width: "100%" }}>
            <center>
              <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
            </center>
          </div>,
        })
        setTimeout(
          function () {
            this.toggle();
          }
            .bind(this),
          5000
        );
      }
    } catch (error) {
      this.setState({
        modalTitulo: "Error",
        modalMensaje:
          <div>
            <center>
              <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <center>
            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
          </center>
        </div>,
      })
      setTimeout(
        function () {
          this.toggle();
        }
          .bind(this),
        5000
      );
    }
  }

  async posponer() {
    try {
      this.setState({
        modalTitulo: "Espera por favor",
        modalMensaje:
          <div>
            <center>
              <p>¡Estamos posponiendo el turno!</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <Progress animated color="success" value="100" />
        </div>,
      })
      this.toggle();
      var envioDatos = this.state.turnoTotal;
      //console.log(envioDatos)
      //console.log(this.state.turnoTotal)
      //envioDatos.observaciones = "Cancelación Observación";

      const response = await axios.get(OBTENER_URL_SERVICIO + "/posponerTurno/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente, envioDatos);
      if (response.data.tipo === "EXITO") {
        this.props.ocuparAgente(false);
        this.setState({
          estadoFlujo: "Finalizado",
          boolNombre: false,
          boolID: false,
          boolCorreo: false,
          boolTelefono: false,
          boolObservaciones: false,
          modalTitulo: "Exito",
          modalMensaje:
            <div>
              <center>
                <p>Turno pospuesto con éxito.</p>
              </center>
            </div>,
          modalFooter: <div>
            <Button onClick={this.toggle}> Aceptar</Button>
          </div>,
        })
      } else {
        if (response.data.tipo === "ERROR") {
          this.setState({
            modalTitulo: "No puedes posponer",
            modalMensaje:
              <Row>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                  <center>
                    <Label>{response.data.mensaje}</Label>
                  </center>
                </Col>
              </Row>,
            modalFooter: <div>
              <Button onClick={this.toggle} color="danger"> Aceptar</Button>
            </div>
          })

        }
      }
    } catch (error) {
      this.setState({
        modalTitulo: "No puedes posponer",
        modalMensaje:
          <Row>
            <Col xs={{ size: 12 }} sm={{ size: 12 }} >
              <center>
                <Label>{error.response.data.mensaje}</Label>
              </center>
            </Col>
          </Row>,
        modalFooter: <div>
          <Button onClick={this.toggle} color="danger"> Aceptar</Button>
        </div>
      })
    }
  }

  async transferir() {
    try {
      this.setState({
        modalTitulo: "Espera por favor",
        modalMensaje:
          <div>
            <center>
              <p>¡Estamos realizando la transferencia del turno!</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <Progress animated color="success" value="100" />
        </div>,
      })
      var envioDatos = this.state.turnoTotal;
      //console.log(envioDatos)
      //console.log(this.state.turnoTotal)
      const response = await axios.post(OBTENER_URL_SERVICIO + "/transferirTurno/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/" + this.state.modalAgenteTransferir.idAgenteBase, envioDatos);
      if (response.data.tipo === "EXITO") {
        this.props.ocuparAgente(false);
        this.setState({
          estadoFlujo: "Finalizado",
          boolNombre: false,
          boolID: false,
          boolCorreo: false,
          boolTelefono: false,
          boolObservaciones: false,
          modalTitulo: "Exito",
          modalMensaje:
            <div>
              <center>
                <p>Turno transferido con éxito.</p>
              </center>
            </div>,
          modalFooter: <div>
            <Button onClick={this.toggle}> Aceptar</Button>
          </div>,
        })
      }
      else {
        this.setState({
          modalTitulo: "Error",
          modalMensaje:
            <div>
              <center>
                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde.</p>
                <p>{response.data.mensaje}</p>
              </center>
            </div>,
          modalFooter: <div>
            <Button onClick={this.toggle} color="danger"> Cancelar</Button>
          </div>,
        })
      }
    } catch (error) {
      this.setState({
        modalTitulo: "Error",
        modalMensaje:
          <div>
            <center>
              <p>Tu solicitud no puede ser enviada ahora mismo.</p>
              <p>{error.response.data.mensaje}</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <center>
            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
          </center>
        </div>,
      })
      setTimeout(
        function () {
          this.toggle();
        }
          .bind(this),
        5000
      );
    }
  }

  async modalTransferir() {
    try {
      this.setState({
        modalTitulo: "Espera por favor",
        modalMensaje:
          <div>
            <center>
              <p>¡Estamos buscando agentes para transferir el turno!</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <Progress animated color="success" value="100" />
        </div>,
      })
      this.toggle();
      const response = await axios.get(OBTENER_URL_SERVICIO + "/agentesCompetentesTransferir/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/" + this.state.turnoTotal.codServicioSeleccionado);
      var agentesX = []
      for (const [key, value] of Object.entries(response.data)) {
        agentesX.push({ id: key, valor: value });
      }
      if (agentesX.length <= 0) {
        this.setState({
          modalTitulo: "Error",
          modalMensaje:
            <div>
              <center>
                <p>En el momento no hay más agentes disponibles para atender este tipo de servicio.</p>
                <p>Por favor intenta de nuevo más tarde o finaliza/cancela la atención.</p>
              </center>
            </div>,
          modalFooter: < div >
            <Button onClick={this.toggle}> Aceptar</Button>
          </div >,
        })
      } else {
        const idAgenteBase = agentesX[0].id;
        const nombreAgenteBase = agentesX[0].valor;
        var transferirBase = this.state.modalAgenteTransferir;
        transferirBase.idAgenteBase = idAgenteBase;
        transferirBase.nombreAgenteBase = nombreAgenteBase;
        this.setState({
          modalAgenteTransferir: transferirBase,
        })
        var opcionesAgentes = agentesX.map(p => {
          return (<option key={p.id} value={p.id} id={p.id}>{p.valor} </option>)
        });
        this.setState({
          modalTitulo: "Agentes Disponibles",
          modalMensaje:
            <div>
              <center>
                <FormGroup>
                  <Label for="exampleSelect">Selecciona un agente para transferir el turno.</Label>
                  <Input onChange={this.handleSelectTransferir} type="select" name="select" id="selectTransferir">
                    {opcionesAgentes}
                  </Input>
                </FormGroup>
              </center>
            </div>,
          modalFooter: <div>
            <Button onClick={this.transferir} color="success"> Confirmar</Button>{' '}
            <Button onClick={this.toggle} color="danger"> Cancelar</Button>
          </div>,
        })
      }
    } catch (error) {
      this.setState({
        modalTitulo: "Error",
        modalMensaje:
          <div>
            <center>
              <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde.</p>
            </center>
          </div>,
        modalFooter: <div style={{ width: "100%" }}>
          <center>
            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
          </center>
        </div>,
      })
      setTimeout(
        function () {
          this.toggle();
        }
          .bind(this),
        5000
      );

    }
  }

  async prioritario() {
    var envioDatos = this.state.modalPrioritario;
    //console.log(envioDatos)
    var hayError = false;
    var regexNumber = /^[0-9]+$/;
    var regexString = /^[A-Za-z ]+$/;
    if (!envioDatos.nombreUsuario.match(regexString) || envioDatos.nombreUsuario === undefined || envioDatos.nombreUsuario === "" || envioDatos.nombreUsuario === null || envioDatos.nombreUsuario.length <= 2 || envioDatos.nombreUsuario.length > 120) {
      hayError = true;
      this.setState({
        modalInvalidNombre: true,
      })
    } else {
      this.setState({
        modalInvalidNombre: false,
      })
    }
    if (!envioDatos.idUsuario.match(regexNumber) || envioDatos.idUsuario === undefined || envioDatos.idUsuario === "" || envioDatos.idUsuario === null || envioDatos.idUsuario.length <= 1 || envioDatos.idUsuario.length > 12) {
      hayError = true;
      this.setState({
        modalInvalidIdentificacion: true,
      })
    } else {
      this.setState({
        modalInvalidIdentificacion: false,
      })
    }
    if (envioDatos.correoUsuario === undefined || envioDatos.correoUsuario === "" || envioDatos.correoUsuario === null || envioDatos.correoUsuario.length <= 4 || envioDatos.correoUsuario.length > 120) {
      hayError = true;
      this.setState({
        modalInvalidCorreo: true,
      })
    } else {
      this.setState({
        modalInvalidCorreo: false,
      })
    }
    // !envioDatos.telefonoUsuario.match(regexNumber) || 
    if (envioDatos.telefonoUsuario === undefined || envioDatos.telefonoUsuario === "" || envioDatos.telefonoUsuario === null || envioDatos.telefonoUsuario.length <= 4 || envioDatos.telefonoUsuario.length > 60) {
      hayError = true;
      this.setState({
        modalInvalidTelefono: true,
      })
    } else {
      this.setState({
        modalInvalidTelefono: false,
      })
    }
    if (envioDatos.observaciones === undefined || envioDatos.observaciones === "" || envioDatos.observaciones === null || envioDatos.observaciones.length <= 9 || envioDatos.observaciones.length > 500) {
      hayError = true;
      this.setState({
        modalInvalidObservaciones: true,
      })
    } else {
      this.setState({
        modalInvalidObservaciones: false,
      })
    }
    if (hayError === true) {
      setTimeout(
        function () {
          var opciones = []
          for (const [key, value] of Object.entries(this.props.agente.mapaServicios)) {
            opciones.push({ id: key, valor: value });
          }
          var opcionesServicio = opciones.map(p => {
            return (<option key={p.id} value={p.id} id={p.valor} name={p.valor}>{p.valor} </option>)
          });
          this.setState({
            modalTitulo: "Atención prioritaria",
            modalMensaje:
              <Row>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                  <center>
                    <Label>Por favor ingresa los datos del usuario:</Label>
                  </center>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Nombre</Label>
                      <Input invalid={this.state.modalInvalidNombre} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.nombreUsuario} bsSize="sm" type="text" name="nombreUsuario" id="nombreUsuario" onChange={this.handleChangeModal} />
                      <FormFeedback tooltip>De 3 a 120 Caracteres</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Identificación</Label>
                      <Input invalid={this.state.modalInvalidIdentificacion} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.idUsuario} bsSize="sm" type="text" name="idUsuario" id="idUsuario" onChange={this.handleChangeModal} />
                      <FormFeedback tooltip>Digita entre 2 a 12 Números</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Correo</Label>
                      <Input invalid={this.state.modalInvalidCorreo} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.correoUsuario} bsSize="sm" type="email" name="correoUsuario" id="correoUsuario" onChange={this.handleChangeModal} />
                      <FormFeedback tooltip>De 5 a 120 Caracteres</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Teléfono</Label>
                      <Input invalid={this.state.modalInvalidTelefono} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.telefonoUsuario} bsSize="sm" type="text" name="telefonoUsuario" id="telefonoUsuario" onChange={this.handleChangeModal} />
                      <FormFeedback tooltip>De 5 a 60 Números</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                  <center>
                    <Label for="exampleEmail">Género</Label>
                  </center>
                  <Input onChange={this.handleSelectGenero} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectGenero" id="selectGenero">
                    <option key={"M"} value={"M"} id={"M"} name={"M"}>M</option>
                    <option key={"F"} value={"F"} id={"F"} name={"F"}>F</option>
                  </Input>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                  <center>
                    <Label for="exampleEmail">Rol</Label>
                  </center>
                  <Input onChange={this.handleSelectRoles} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                    <option key={"2"} value={"2"} id={"EXTERNO"} name={"EXTERNO"}>EXTERNO</option>
                    <option key={"1"} value={"1"} id={"ESTUDIANTE"} name={"ESTUDIANTE"}>ESTUDIANTE</option>
                    <option key={"3"} value={"3"} id={"EMPLEADO"} name={"EMPLEADO"}>EMPLEADO</option>
                  </Input>
                </Col>
                <Col xs={{ size: 12 }}>
                  <center>
                    <Label for="exampleEmail">Servicio brindado</Label>
                  </center>
                  <Input onChange={this.handleSelectServicio} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectServicio" id="selectServicio">
                    {opcionesServicio}
                  </Input>
                </Col>
                <Col xs={{ size: 12 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Observaciones del servicio</Label>
                      <Input invalid={this.state.modalInvalidObservaciones} style={{ marginTop: "-12px", marginBottom: "7px", resize: "none" }} value={this.state.observaciones} type="textarea" name="observaciones" id="observaciones" onChange={this.handleChangeModal} />
                      <FormFeedback tooltip>De 10 a 120 Caracteres</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <MensajeModal modal={this.state.nestedModalEstado} titulo={this.state.nestedModalTitulo} toggle={this.nestedToggle} mensaje={this.state.nestedModalMensaje} footer={this.state.nestedModalFooter} ></MensajeModal>
              </Row>,
            modalFooter: <div>
              <Button onClick={this.prioritario} color="success"> Confirmar</Button>{' '}
              <Button onClick={this.toggle} color="danger"> Cancelar</Button>
            </div>
          })
          return null;
        }
          .bind(this),
        10
      );
    } else {
      try {

        //console.log(envioDatos)
        this.setState({
          modalTitulo: "Espera por favor",
          modalMensaje:
            <div>
              <center>
                <p>¡Estamos registrando el turno!</p>
              </center>
            </div>,
          modalFooter: <div style={{ width: "100%" }}>
            <Progress animated color="success" value="100" />
          </div>,
        })
        const response = await axios.post(OBTENER_URL_SERVICIO + "/turnoPriorizado/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente, envioDatos);
        console.log(response.data)
        if (response.data.tipo === "EXITO") {
          var serviciosX = []
          for (const [key, value] of Object.entries(this.props.agente.mapaServicios)) {
            serviciosX.push({ id: key, valor: value });
          }
          const idServicioBase = serviciosX[0].id;
          const nomServicioBase = serviciosX[0].valor;
          const m = {
            nombreUsuario: "",
            idUsuario: "",
            rolUsuario: "EXTERNO",
            idRolUsuario: "2",
            generoUsuario: "M",
            observaciones: "",
            correoUsuario: "",
            telefonoUsuario: "",
            idServicio: idServicioBase,
            nombreServicio: nomServicioBase,
          }
          this.setState({
            estadoFlujo: "Finalizado",
            boolNombre: false,
            boolID: false,
            boolCorreo: false,
            boolTelefono: false,
            boolObservaciones: false,
            modalPrioritario: m,
          })
          this.toggle();
        } else {
          this.setState({
            modalTitulo: "Error",
            modalMensaje:
              <div>
                <center>
                  <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde.</p>
                </center>
              </div>,
            modalFooter: <div style={{ width: "100%" }}>
              <center>
                <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
              </center>
            </div>,
          })
          setTimeout(
            function () {
              this.toggle();
            }
              .bind(this),
            5000
          );
        }
      } catch (error) {
        this.setState({
          modalTitulo: "Error",
          modalMensaje:
            <div>
              <center>
                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde.</p>
              </center>
            </div>,
          modalFooter: <div style={{ width: "100%" }}>
            <center>
              <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
            </center>
          </div>,
        })
        setTimeout(
          function () {
            this.toggle();
          }
            .bind(this),
          5000
        );
      }
    }
  }

  modalAtencionPrioritaria() {
    var opciones = []
    for (const [key, value] of Object.entries(this.props.agente.mapaServicios)) {
      opciones.push({ id: key, valor: value });
    }
    var opcionesServicio = opciones.map(p => {
      return (<option key={p.id} value={p.id} id={p.valor} name={p.valor}>{p.valor} </option>)
    });
    this.setState({
      modalTitulo: "Atención prioritaria",
      modalMensaje:
        <Row>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} >
            <center>
              <Label>Por favor ingresa los datos del usuario:</Label>
            </center>
          </Col>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
            <center>
              <FormGroup>
                <Label for="exampleEmail">Nombre</Label>
                <Input invalid={this.state.modalInvalidNombre} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.nombreUsuario} bsSize="sm" type="text" name="nombreUsuario" id="nombreUsuario" onChange={this.handleChangeModal} />
                <FormFeedback tooltip>Por favor valida el nombre</FormFeedback>
              </FormGroup>
            </center>
          </Col>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
            <center>
              <FormGroup>
                <Label for="exampleEmail">Identificación</Label>
                <Input invalid={this.state.modalInvalidIdentificacion} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.idUsuario} bsSize="sm" type="text" name="idUsuario" id="idUsuario" onChange={this.handleChangeModal} />
                <FormFeedback tooltip>Por favor valida la identificación</FormFeedback>
              </FormGroup>
            </center>
          </Col>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
            <center>
              <FormGroup>
                <Label for="exampleEmail">Correo</Label>
                <Input invalid={this.state.modalInvalidCorreo} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.correoUsuario} bsSize="sm" type="email" name="correoUsuario" id="correoUsuario" onChange={this.handleChangeModal} />
                <FormFeedback tooltip>Por favor valida el correo</FormFeedback>
              </FormGroup>
            </center>
          </Col>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
            <center>
              <FormGroup>
                <Label for="exampleEmail">Teléfono</Label>
                <Input invalid={this.state.modalInvalidTelefono} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.telefonoUsuario} bsSize="sm" type="text" name="telefonoUsuario" id="telefonoUsuario" onChange={this.handleChangeModal} />
                <FormFeedback tooltip>Por favor valida el teléfono</FormFeedback>
              </FormGroup>
            </center>
          </Col>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
            <center>
              <Label for="exampleEmail">Género</Label>
            </center>
            <Input onChange={this.handleSelectGenero} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectGenero" id="selectGenero">
              <option key={"M"} value={"M"} id={"M"} name={"M"}>M</option>
              <option key={"F"} value={"F"} id={"F"} name={"F"}>F</option>
            </Input>
          </Col>
          <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
            <center>
              <Label for="exampleEmail">Rol</Label>
            </center>
            <Input onChange={this.handleSelectRoles} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
              <option key={"2"} value={"2"} id={"EXTERNO"} name={"EXTERNO"}>EXTERNO</option>
              <option key={"1"} value={"1"} id={"ESTUDIANTE"} name={"ESTUDIANTE"}>ESTUDIANTE</option>
              <option key={"3"} value={"3"} id={"EMPLEADO"} name={"EMPLEADO"}>EMPLEADO</option>
            </Input>
          </Col>
          <Col xs={{ size: 12 }}>
            <center>
              <Label for="exampleEmail">Servicio brindado</Label>
            </center>
            <Input onChange={this.handleSelectServicio} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectServicio" id="selectServicio">
              {opcionesServicio}
            </Input>
          </Col>
          <Col xs={{ size: 12 }}>
            <center>
              <FormGroup>
                <Label for="exampleEmail">Observaciones del servicio</Label>
                <Input invalid={this.state.modalInvalidObservaciones} style={{ marginTop: "-12px", marginBottom: "7px", resize: "none" }} value={this.state.observaciones} type="textarea" name="observaciones" id="observaciones" onChange={this.handleChangeModal} />
                <FormFeedback tooltip>Por favor valida las observaciones</FormFeedback>
              </FormGroup>
            </center>
          </Col>
          <MensajeModal modal={this.state.nestedModalEstado} titulo={this.state.nestedModalTitulo} toggle={this.nestedToggle} mensaje={this.state.nestedModalMensaje} footer={this.state.nestedModalFooter} ></MensajeModal>
        </Row>,
      modalFooter: <div>
        <Button onClick={this.prioritario} color="success"> Confirmar</Button>{' '}
        <Button onClick={this.toggle} color="danger"> Cancelar</Button>
      </div>
    })
    this.toggle();
  }

  render() {

    //console.log(this.state.turnoActual);
    //console.log(this.state.modalPrioritario);
    //console.log(this.props.agente)
    //console.log(this.state.turnoTotal)
    var botonesAccion;
    switch (this.state.estadoFlujo) {
      case "Finalizado":
        botonesAccion =
          <Row>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} color="success" onClick={this.llamarSiguiente}>Siguiente</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="danger">Finalizar</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} color="danger" onClick={this.modalAtencionPrioritaria}>Prioritario</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="warning">Posponer</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="info">Transferir</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled >Cancelar</Button>
            </Col>
          </Row>;
        break;
      case "En Atencion":
        botonesAccion =
          <Row>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="success">Siguiente</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} color="danger" onClick={this.finalizar}>Finalizar</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="danger">Atención Prioritaria</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} color="warning" onClick={this.posponer}>Posponer</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} color="info" onClick={this.modalTransferir}>Transferir</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} onClick={this.cancelar}>Cancelar</Button>
            </Col>
          </Row>;
        break;
      default:
        botonesAccion =
          <Row>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="success">Siguiente</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="danger">Finalizar</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="danger">Atención Prioritaria</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="warning">Posponer</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled color="info">Transferir</Button>
            </Col>
            <Col xs={{ size: 12 }} sm={{ size: 6 }} md={{ size: 4 }}>
              <Button style={{ width: "100%", marginBottom: "7px" }} disabled >Cancelar</Button>
            </Col>
          </Row>;
    }
    return (
      <Card>
        <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
        <CardBody>
          <Row>
            <Col xl={{ size: 5 }} lg={{ size: 5 }} md={{ size: 5 }} sm={{ size: 12 }}>
              <Card>
                <CardBody>
                  <center>
                    <Label for="estadoModulo">Turno Actual</Label>
                    <p />
                    <Label style={{ fontSize: "30px", marginTop: "-15px" }} for="estadoModulo">{this.state.turnoActual.idTurno}</Label>
                    <FormGroup>
                      <FormGroup>
                        <Label for="exampleEmail">Nombre usuario</Label>
                        <Input invalid={this.state.invalidNombre} type="text" name="usuario" id="usuario" disabled={!this.state.boolNombre} value={this.state.turnoActual.usuario} onChange={this.handleChangeDatos} />
                        <FormFeedback tooltip>Por favor valida el nombre</FormFeedback>
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleEmail">ID del usuario</Label>
                        <Input invalid={this.state.invalidIdentificacion} type="text" name="idUsuario" id="idUsuario" disabled={!this.state.boolID} value={this.state.turnoActual.idUsuario} onChange={this.handleChangeDatos} />
                        <FormFeedback tooltip>Por favor valida el ID</FormFeedback>
                      </FormGroup>
                      <p />
                      <Label for="exampleEmail">Nombre del servicio: {this.state.turnoActual.nombreServicio}</Label>
                      <p />
                      <Label for="exampleEmail">Estado: {this.state.estadoFlujo}</Label>.
                      <p />
                      <Label>Fecha de inicio de atención del servicio: {new Date(this.state.turnoTotal.horaAtencion).toLocaleString("es-CO")}</Label>
                    </FormGroup>
                  </center>
                </CardBody>
              </Card>
            </Col>
            <Col xl={{ size: 7 }} lg={{ size: 7 }} md={{ size: 7 }} sm={{ size: 12 }}>
              <FormGroup>
                <Col xs={{ size: 12 }} sm={{ size: 12 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Correo del usuario</Label>
                      <Input invalid={this.state.invalidCorreo} style={{ marginTop: "-12px", marginBottom: "7px" }} disabled={!this.state.boolCorreo} bsSize="sm" type="email" name="correoUsuario" id="correoUsuario" value={this.state.turnoActual.correoUsuario} onChange={this.handleChangeDatos} />
                      <FormFeedback tooltip>Por favor valida el correo</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <Col xs={{ size: 12 }} sm={{ size: 12 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Teléfono del usuario</Label>
                      <Input invalid={this.state.invalidTelefono} style={{ marginTop: "-12px", marginBottom: "7px" }} disabled={!this.state.boolTelefono} bsSize="sm" type="text" name="telefonoUsuario" id="telefonoUsuario" value={this.state.turnoActual.telefonoUsuario} onChange={this.handleChangeDatos} />
                      <FormFeedback tooltip>Por favor valida el teléfono</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
                <Col xl={{ size: 12 }}>
                  <center>
                    <FormGroup>
                      <Label for="exampleEmail">Observaciones del servicio</Label>
                      <Input invalid={this.state.invalidObservaciones} style={{ marginTop: "-12px", marginBottom: "7px", resize: "none" }} disabled={!this.state.boolObservaciones} type="textarea" name="observacionesServicio" id="observacionesServicio" value={this.state.turnoActual.observacionesServicio} onChange={this.handleChangeDatos} />
                      <FormFeedback tooltip>Por favor valida las observaciones</FormFeedback>
                    </FormGroup>
                  </center>
                </Col>
              </FormGroup>
              <center>
                <Col xs={{ size: 12 }}>
                  <Label for="estadoModulo">Acciones del Turno</Label>
                </Col>
              </center>
              {botonesAccion}
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DatosAtencionAgente);
